import createBaseLayer from './base-layer';

export default (props, model) => {
  const self = createBaseLayer(model);

  model.layerType = 'annotation';

  // hack alert. Todo: standardize approach of identifying layer type
  model.isAnnotLayer = true;

  return self;
};



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/layer/types/annotation-layer.js